<template>
  <div class="index">
    <div class="main-wrap">
      <div>
        <div class="wrapper">
          <jm-crumbs/>
          <div class="taskExample">
            <div class="basic-title"><em>{{ taskName }}</em></div>
            <el-form
              :model="formData"
              class="exampleTable">
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <span class="span155">标题：</span>
                    <el-input
                      class="input452"
                      v-model="formData.title"/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <span class="span155"/>
                    <jm-upload
                      class="upload-demo"
                      ref="upload"
                      action="/index/task/uploadExample"
                      :on-change="handleUpload"
                      :show-file-list="false"
                      :auto-upload="false"
                      :before-upload="uploadExample">
                      <el-button size="small" type="primary">选择文件</el-button>
                    </jm-upload>
                    <el-button size="small" type="success" @click="uploadExample">上传服务器</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-table
                    class="tableList"
                    :data="examplesData"
                    style="width: 100%">
                    <el-table-column
                      label="名称"
                      prop="title"
                    />
                    <el-table-column
                      label="图片"
                      prop="imgurl"
                    />
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          type="danger"
                          @click="deleteExample(scope.row)">删除
                        </el-button>
                        <el-button
                          size="mini"
                          type="primary"
                          @click="moveTopOrBottom(scope.row,1)">上移
                        </el-button>
                        <el-button
                          size="mini"
                          type="primary"
                          @click="moveTopOrBottom(scope.row,2)">下移
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <router-link
                      target="_blank"
                      :to="{ name: 'tasklist',params: { country: country}}">
                      <div style="text-align: center"><el-button
                        type="primary"
                        class="btn-return">返回</el-button></div>
                    </router-link>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
    .exampleTable {
        margin-left: 46px;
    }

    .span155 {
        width: 155px;
        display: inline-block;
    }

    .input452 {
        width: 452px;
    }

    .myupload {
        display: inline-block;
    }

    .uploadFile button {
        width: 100px;
        height: 45px;
    }
    .btn-return{
        margin-top: 20px;
    }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
// import jmUpload from '@/components/tool/upload.vue';

export default {
  data() {
    return {
      country: this.$route.params.country,
      taskName: '',
      formData: {
        title: '',
        uploadImgurl: '',
        tpl_url: '',
        taskId: this.$route.params.taskId,
      },
      examplesData: [
        {
          name: '111',
          img: '222',
        }
      ],
      file: null,
    };
  },
  components: {
    'jm-crumbs': crumbs,
    // 'jm-upload': jmUpload
  },
  methods: {
    getExample() {
      let taskId = this.$route.params.taskId;
      this.$http._get({
        url: `/index/Task/getExampleInfo?taskId=${taskId}`
      }).then(({ data }) => {
        console.log(data);
        this.taskName = data.file_name;
        this.formData.tpl_url = data.file_url;
      });
    },
    getExampleList() {
      let taskId = this.$route.params.taskId;
      this.$http._get({
        url: `/index/Task/getExampleList?taskId=${taskId}`
      }).then(({ data }) => {
        console.log(data);
        this.examplesData = data;
      });
    },
    submitUpload() {
      this.uploadExample();
    },
    uploadChange(file) {
      this.$message.info(`'${file.name}'文件以被选择，请选择点击上传！`);
    },
    handleUpload(file) {
      this.file = file;
    },
    uploadExample() {
      let country = this.$route.params.country;
      if (this.file === null) {
        this.$message.error('没有文件,请选择文件！');
        return;
      }
      let fileSize = this.file.size;
      let maxSize = 1024 * 1024 * 4;
      if (fileSize > maxSize) {
        this.$message.error('文件大小不能超过4M!');
      } else {
        let form = new FormData();
        form.append('fileToUpload', this.file.raw);
        form.append('country', country);
        form.append('title', this.formData.title);
        form.append('tpl_url', this.formData.tpl_url);
        form.append('taskId', this.formData.taskId);
        this.$http
          ._post({
            url: '/index/Task/addExample',
            data: form,
          })
          .then((data) => {
            if (data.result === 0) {
              this.getExample();
              this.getExampleList();
              this.formData.title = '';
              this.$message.success('添加例子成功');
            } else {
              this.$message.error('添加例子失败');
            }
          });
      }
    },
    // addExample() {
    //   console.log('testtest', this.formData);
    //   this.$http
    //     ._post({
    //       url: '/index/Task/addExample',
    //       data: this.formData,
    //     })
    //     .then((data) => {
    //       if (data.result === 0) {
    //         this.getExample();
    //         this.getExampleList();
    //         this.formData.title = '';
    //         this.$message.success('添加例子成功');
    //       } else {
    //         this.$message.error('添加例子失败');
    //       }
    //     });
    // },
    deleteExample(row) {
      console.log(row);
      let example = {
        country: this.$route.params.country,
        id: row.id,
        imgurl: row.imgurl,
      };
      this.$http
        ._post({
          url: '/index/Task/deleteExample',
          data: example,
        })
        .then((data) => {
          if (data.result === 0) {
            this.getExampleList();
            this.formData.title = '';
            this.$message.success('删除例子成功');
          } else {
            this.$message.error('删除例子失败');
          }
        });
    },
    moveTopOrBottom(row, option) {
      let example = {
        taskId: this.$route.params.taskId,
        exampleId: row.id,
        sorts: row.sorts,
        option: option,
      };
      this.$http
        ._post({
          url: '/index/Task/moveTopOrBottom',
          data: example,
        })
        .then((data) => {
          if (data.result === 0) {
            this.getExampleList();
          }
        });
    }
  },
  mounted() {
    this.getExample();
    this.getExampleList();
  }
};
</script>
